const Config = {
  BulkTagMaintenance: {
    maxCSVrecords: 60000,
  },
};
export default Config;
